import { Builder } from '@builder.io/react'
import React from 'react'

import { HeadingClass, HeadingType } from 'enums'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundImage: any
  // cloudinaryImage: any
  builderImage: any
  imageAltText: string
  headingText: string
  headingTextColor: string
  contentText: string
  headingType: HeadingType
  headingClass: HeadingClass
  textAlignment: Alignment
  imageSeparate: boolean
}

const TopTextImage = ({
  backgroundImage = '',
  // cloudinaryImage,
  builderImage,
  imageAltText = '',
  headingText,
  headingTextColor,
  contentText,
  headingType,
  headingClass,
  textAlignment,
  imageSeparate
}: Props) => {
  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const getContent = () => {
    if (imageSeparate) {
      return (
        <div className="flex flex-col items-center justify-start lg:h-[22rem] xl:h-[21rem] lg:flex-row lg:items-start lg:py-4">
          <div className="ml-2 mb-4 flex w-full flex-col items-center justify-center text-center lg:mb-0 lg:w-[60%] xl:w-[50%]">
            <div className="w-full">
              <CustomHeading
                classList="line-height-fix w-full h-full tracking-tight text-gray-900 text-left font-medium text-center lg:text-left"
                headingClass={headingClass}
                headingType={headingType}
                color={headingTextColor}
              >
                {headingText}
              </CustomHeading>
            </div>
            <p
              className={`enable-list-styles my-4 h-full w-full text-center text-base lg:text-left ${getAlignmentClass()}`}
              dangerouslySetInnerHTML={{ __html: contentText }}
            ></p>
          </div>

          <div className="relative w-full xl:px-8 lg:w-[50%] flex justify-center">
            <CdnImage
              className="relative object-contain w-full lg:w-5/6 2xl:w-1/2"
              url={builderImage}
              alt={imageAltText}
              steps={[400, 640]}
            />
            {/* {builderImage ? (
              <CdnImage
                className="relative object-contain w-full lg:w-5/6 2xl:w-1/2"
                url={builderImage}
                alt={imageAltText}
                steps={[400, 640]}
              />
            ) : (
              <CloudinaryImage
                className="relative object-contain w-full lg:w-5/6 2xl:w-1/2"
                publicId={cloudinaryImage?.public_id}
                alt={imageAltText}
                steps={[400, 640]}
              />
            )} */}
          </div>
        </div>
      )
    } else {
      return (
        <div className=" flex flex-col items-center justify-start lg:h-[22rem] xl:h-[21rem] lg:flex-row lg:items-start lg:py-4">
          <div className="ml-2 mb-12 xs:mb-32 flex w-full flex-col items-center justify-center text-center lg:mb-0 lg:w-[35%] xl:w-1/2">
            <div className="w-full">
              <CustomHeading
                classList="line-height-fix w-full h-full tracking-tight text-gray-900 text-left font-medium text-center lg:text-left px-4 lg:px-0"
                headingClass={headingClass}
                headingType={headingType}
                color={headingTextColor}
              >
                {headingText}
              </CustomHeading>
            </div>
            <p
              className={`enable-list-styles my-4 h-full w-full text-center text-base lg:text-left ${getAlignmentClass()}`}
              dangerouslySetInnerHTML={{ __html: contentText }}
            ></p>
          </div>
          <div className="p-8">
            <CdnImage
              className="absolute -bottom-2 -right-5 h-50 object-contain w-[30rem] md:right-10 lg:-bottom-4 lg:-right-8 lg:mt-0 lg:w-[40rem]"
              url={builderImage}
              alt={imageAltText}
              steps={[400, 640]}
              // renderPlaceholder={false}
            />
            {/* {builderImage ? (
              <CdnImage
                className="absolute -bottom-2 -right-5 h-50 object-contain w-[30rem] md:right-10 lg:-bottom-4 lg:-right-8 lg:mt-0 lg:w-[40rem]"
                url={builderImage}
                alt={imageAltText}
                steps={[400, 640]}
                // renderPlaceholder={false}
              />
            ) : (
              <CloudinaryImage
                className="absolute -bottom-2 -right-5 h-50 object-contain w-[30rem] md:right-10 lg:-bottom-4 lg:-right-8 lg:mt-0 lg:w-[40rem]"
                publicId={cloudinaryImage?.public_id}
                alt={imageAltText}
                steps={[400, 640]}
              />
            )} */}
          </div>
        </div>
      )
    }
  }

  return (
    <>
      <div
        className="index-1 h-20rem relative mx-auto mt-12 flex w-4/5 flex-col items-center justify-center bg-white bg-auto bg-no-repeat lg:flex-row lg:bg-100%"
        style={{ backgroundImage: `url(${backgroundImage ?? ''})` }}
      >
        {getContent()}
      </div>
    </>
  )
}

export default TopTextImage

Builder.registerComponent(TopTextImage, {
  name: 'TopTextImage',
  inputs: [
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: null
    },
    // {
    //   name: 'cloudinaryImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'Javascript for Beginners'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'imageSeparate',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
